import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	signal,
	WritableSignal,
} from '@angular/core';

import { FormControl } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateService } from '@tolgee/ngx';
import { NgxTolgeeModule } from '@tolgee/ngx';
@Component({
	selector: 'asset-condition-grade',
	imports: [MatTooltipModule, NgxTolgeeModule],
	templateUrl: './asset-condition-grade.component.html',
	styleUrls: ['./asset-condition-grade.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetConditionGradeComponent implements OnInit {
	@Input() set conditionGrade(grade: number) {
		this.formControl.patchValue(grade);
		this.selectedItem.set(grade);
	}
	@Input() showLabel = true;
	@Input() showOptions = true;
	@Input() staticValue = false;
	@Output() controlReady = new EventEmitter<FormControl>();
	@Output() conditionGradeChanged = new EventEmitter<number>();

	formControl = new FormControl(null);

	grades: WritableSignal<number[]> = signal([-1, 0, 1, 2, 3]);
	selectedItem: WritableSignal<number | null> = signal(null);

	constructor(private translateService: TranslateService) {}

	ngOnInit(): void {
		this.controlReady.emit(this.formControl);
	}

	toggleSelection(grade: number) {
		if (this.selectedItem() === grade) {
			// If the same item is clicked again, deselect it
			this.selectedItem.set(null);
		} else {
			// Select a different item
			this.selectedItem.set(grade);
		}
		this.formControl.patchValue(this.selectedItem());
		this.conditionGradeChanged.emit(this.selectedItem());
	}

	getTooltipText(grade: number): string {
		if (grade === -1) {
			return this.translateService.instant('condition_grade_not_inspected');
		}
		const gradesTooltips = {
			0: this.translateService.instant('condition_grade_0'),
			1: this.translateService.instant('condition_grade_1'),
			2: this.translateService.instant('condition_grade_2'),
			3: this.translateService.instant('condition_grade_3'),
		};
		return gradesTooltips[grade];
	}
}
